module.exports = __webpack_public_path__ + "img/ic-droplet.23645a46.svg";